import { generateResources } from 'utils/GenerateResouces';

const resource = {
  name: 'hermes/gateways',
  label: 'Gateways Hermes',
  actions: ['list', 'show'],
  onlyPermission: true,
  parentName: 'financial'
};

export default generateResources(resource);
